<template>
  <div class="component">
    <div class="component-title">装卸搬运费计算规则</div>
    <div style="font-size: 12px;line-height: 28px;color: #C9C2BB;">计算公式：总费用=基础费用+楼层费+大件货+卡板+箱子</div>
    <div style="font-size: 12px;color: #FFBD2D;line-height: 12px;margin-bottom: 16px;">（其他费用根据商议结果决定）</div>
    <table style="margin-bottom: 8px;">
      <tbody>
        <tr style="height: 74px;">
          <td width="17%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">散货</td>
          <td width="15%" style="font-size: 12px;">基础费</td>
          <td width="22%" style="font-size: 12px;">楼层费/层</td>
          <td width="46%">
            <tr style="display: flex;height: 37px;"><td colspan="2" width="100%" style="font-size: 12px;line-height: 37px;">大件货/件</td></tr>
            <tr style="display: flex;height: 37px;">
              <td width="50%" style="font-size: 12px;line-height: 37px;">基础费/件</td>
              <td width="50%" style="font-size: 12px;line-height: 37px;">楼层费/层</td>
            </tr>
          </td>
        </tr>
        <tr style="height: 46px;" v-for="item in carAttributeFeeConfig.bulkCargoFeeInfo" :key="item.id">
          <td width="17%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">{{ bulkCargoFeeTypeOptions[item.itemType] ? bulkCargoFeeTypeOptions[item.itemType] : "未知类型" }}</td>
          <td width="15%" style="font-size: 12px;">{{ $zeroPadding(item.baseFee) }}元</td>
          <td width="22%" style="font-size: 12px;">{{ $zeroPadding(item.baseFloorFee) }}元</td>
          <td width="46%">
            <tr style="display: flex;height: 46px;">
              <td width="50%" style="font-size: 12px;line-height: 46px;">{{ $zeroPadding(item.bulkCargoFee) }}元</td>
              <td width="50%" style="font-size: 12px;line-height: 46px;">{{ $zeroPadding(item.bulkCargoFloorFee) }}元</td>
            </tr>
          </td>
        </tr>
      </tbody>
    </table>
    <table>
      <tbody>
        <tr style="height: 46px;">
          <td width="17%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">类型</td>
          <td width="30%" style="font-size: 12px;">基础费用</td>
          <td width="27%" style="font-size: 12px;">上楼费（电梯）</td>
          <td width="26%" style="font-size: 12px;">其他</td>
        </tr>
        <tr style="height: 46px;">
          <td width="17%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">卡板</td>
          <td width="30%" style="font-size: 12px;">{{ $zeroPadding(carAttributeFeeConfig.otherFeeInfo.palletConfigFee) }}元/板</td>
          <td width="27%" style="font-size: 12px;">{{ $zeroPadding(carAttributeFeeConfig.otherFeeInfo.palletFloorConfigFee) }}元/板</td>
          <td width="26%" style="font-size: 12px;">商议</td>
        </tr>
        <tr style="height: 46px;">
          <td width="17%" style="font-size: 14px;font-weight: bold;font-family: DIN-Medium;">箱子</td>
          <td width="30%" style="font-size: 12px;">{{ $zeroPadding(carAttributeFeeConfig.otherFeeInfo.boxConfigFee) }}元/板</td>
          <td width="27%" style="font-size: 12px;">{{ $zeroPadding(carAttributeFeeConfig.otherFeeInfo.boxFloorConfigFee) }}元/板</td>
          <td width="26%" style="font-size: 12px;">商议</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name:"LoadingUnloadingFee",
  props:["carAttributeFeeConfig"],
  data(){
    return {
      bulkCargoFeeTypeOptions:{
        complete:"整车",
        half:"半车",
        none:"默认"
      }
    }
  }
}
</script>

<style scoped lang="scss">
 table,
th,
td {
  border: 1px solid #C9C2BB;
}

table {
  width: 100%;
  margin: 0 auto;
  display: table;
  border-spacing: 0;
  border-radius: 4px;
  overflow: hidden;
}
th,
td {
  border-top-width: 0;
  border-left-width: 0;
  text-align: center;
}

th:last-child,
td:last-child {
  border-right-width: 0;
}

tr:last-child td {
  border-bottom-width: 0;
}

td tr td{
  border-top: 1px solid #C9C2BB;
}
td tr:first-child td {
  border-top: 0;
  border-bottom: 0;
}
table tbody > tr > td:first-child {
  background-color: #F8F8F8;
}
</style>